var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-page',[_c('b-container',{staticClass:"text-center"},[_c('vue-slot-machine')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }